export default __webpack_public_path__ + "static/Masiak-be79f6867c2afe248ef7de3a0a66724e.jpg";